import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/20/solid";
import { useHomeStrings } from "../../../i18n";

export default function FAQ() {
  const t = useHomeStrings().faq;
  const faqs = t.items;

  return (
    <div className="bg-transparent" id="faq">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-foreground text-center mb-12">
          {t.heading}
        </h2>
        <div className="rounded-xl shadow-sm border border-border/60">
          {faqs.map((faq, index) => (
            <Disclosure key={faq.question}>
              {({ open }) => (
                <div
                  className={`${
                    index === 0 ? "rounded-t-xl" : ""
                  } ${index === faqs.length - 1 ? "rounded-b-xl" : ""}
                   overflow-hidden border-t border-border/60 first:border-t-0`}
                >
                  <Disclosure.Button className="flex justify-between items-center w-full px-6 py-4 text-left text-base font-medium text-foreground bg-background-elevated hover:bg-background-soft transition-all duration-200">
                    <span>{faq.question}</span>
                    <ChevronUpIcon
                      className={`${
                        open ? "transform rotate-180" : ""
                      } w-5 h-5 text-accent transition-transform duration-200`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel unmount={false} className="px-6 py-4 text-sm text-muted-foreground/90 bg-background-elevated border-t border-border/40">
                    {faq.answer}
                  </Disclosure.Panel>
                </div>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </div>
  );
}
